import { Component, Input, Output, EventEmitter, ViewChild, Injectable } from "@angular/core";
import { ModalDirective } from "ngx-bootstrap/modal";
import { Filters } from "../../../common/components";

export interface ISearchBoxDlgDelegate {
  closeFilterDlg: (modalDlg: SearchBoxDlg, filters: Filters) => void;
}

@Injectable({ providedIn: "any" })
export class SearchBoxDlgDelegate implements ISearchBoxDlgDelegate {
  @Input() searchCriteria: string;
  @Input() filters: any[];
  @Output() searchCriteriaChanged: EventEmitter<string> = new EventEmitter<string>();

  updateSearchCriteria(criteria: string) {
    this.searchCriteria = criteria;
    this.searchCriteriaChanged.emit(this.searchCriteria);
  }

  openFilterDlg(modalDlg: SearchBoxDlg, filters: Filters) {
    filters.state = this.searchCriteria;
    modalDlg.show();
  }

  closeFilterDlg(modalDlg: SearchBoxDlg, filters: Filters) {
    modalDlg.hide();
    this.updateSearchCriteria(filters.state);
  }
}

@Component({
  selector: "search-box-dlg",
  templateUrl: "./search-box-dlg.html",
  standalone: false,
})
export class SearchBoxDlg {
  @Input() delegate: ISearchBoxDlgDelegate;
  @Input() filters: Filters;
  @ViewChild("dlg") dlg: ModalDirective;

  show() {
    this.dlg.show();
  }

  hide() {
    this.dlg.hide();
  }
}
